<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
  @import './scss/colours.scss';
  @import './scss/mixins.scss';
  @import './scss/loader.scss';

  html {
    width: 100%;
    height: 100%;
    overflow: auto;
  }

  body {
    width: 100%;
    height: 100%;
  }

  #app{
    overflow-x: hidden;
    position: relative;

    *{
      font-family: 'Heebo', Helvetica, Arial, sans-serif;
      font-weight: 400;
    }

    h1, h2, h3, h4, h5, h6{
      font-family: 'Heebo', Helvetica, Arial, sans-serif;
      font-weight: 700;
    }
  }

  a{
    color: #999;

    &:hover{
      color: #bbb;
    }
  }

  .page{
    & > section{
      margin-top: 0px;
      padding-bottom: 1em;

      &.landing{
        margin-top: 0;
      }

      .text-content-wrapper{
        padding: 1em;
      }
    }

    h1{
      color: $red;
      margin-bottom: 0.5em;
      //line-height: 2.5rem;
    }

    .block{
      padding-bottom: 0.75em;
    }
  }

  .banner{
    width: 100%;
    height: auto;
    margin-bottom: 3em;
    overflow: hidden;

    .banner-image{
      width: 100%;
      height: auto;
      transform-origin: center center;
      animation: banner-image-animation ease-in-out 20s infinite;
    }
  }

  .half-vh{
    @media (min-width: 992px) and (orientation: landscape) {
      height: 50vh;
    }
  }

  @keyframes banner-image-animation{
    0%{
      transform: scale(1);
    }
    50%{
      transform: scale(1.025);
    }
    100%{
      transform: scale(1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue